(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/mini/helpers/handlebarhelper.js') >= 0) return;  svs.modules.push('/components/statistics/mini/helpers/handlebarhelper.js'); 
(function() {
  'use strict';

  if (typeof exports === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    hbs.registerHelper('renderBarChart', function(home, away, percentage) {
      var ret = '',
        homeNumber = parseInt(home, 10),
        awayNumber = parseInt(away, 10),
        total = homeNumber + awayNumber,
        homePercent = total === 0 ? 50 : Math.round((homeNumber / total) * 100),
        awayPercent = total === 0 ? 50 : 100 - homePercent;

      ret +=
        '<span class="home-label spread f-inverted">' +
        home +
        (percentage ? '%' : '') +
        '</span>';
      ret += '<span class="spread f-middle">';
      ret += '<span class="chart spread-container span12">';
      ret +=
        '<span class="bar-home spread bar" style="width:' +
        homePercent +
        '%;"></span>';
      ret +=
        '<span class="bar-away spread bar less" style="width:' +
        awayPercent +
        '%;"></span>';
      ret += '</span>';
      ret += '</span>';
      ret +=
        '<span class="away-label spread f-inverted">' +
        away +
        (percentage ? '%' : '') +
        '</span>';

      return new Handlebars.SafeString(ret);
    });

    function renderMutuals(mutuals, showTie) {
      var ret = '';
      var home = mutuals.homeWins;
      var tie = mutuals.draws;
      var away = mutuals.awayWins;
      var total = home + tie + away;

      ret += '<ul class="three-bars span12 spread-container">';
      ret +=
        '<li style="width:' +
        Math.round((home / total) * 100) +
        '%" class="spread three-bar three-bar-dominant">' +
        home +
        '</li>';
      if (showTie !== false) {
        ret +=
          '<li style="width:' +
          Math.round((tie / total) * 100) +
          '%" class="spread three-bar three-bar-tie">' +
          tie +
          '</li>';
      }
      ret +=
        '<li style="width:' +
        Math.round((away / total) * 100) +
        '%" class="spread three-bar">' +
        away +
        '</li>';
      ret += '</ul>';

      return ret;
    }

    hbs.registerHelper('renderMutuals', function(mutuals, showTie) {
      var ret = renderMutuals(mutuals, showTie);
      return new Handlebars.SafeString(ret);
    });

    hbs.registerHelper('hasSavedGoals', function(item, options) {
      if (item.matchSavedGoalsPercent !== '0,00') {
        return options.fn(this);
      }

      return options.inverse(this);
    });
  }
})();

 })(window);